// Runs a callback once an element is within a screen of the viewport. Without IntersectionObserver
// everything counts as near.
export class Nearby {
	private observer?: IntersectionObserver;
	private waiting = new Map<Element, () => void>();

	watch(element: Element, run: () => void): () => void {
		if (typeof IntersectionObserver === "undefined") {
			run();
			return () => undefined;
		}
		this.observer ??= new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					const run = entry.isIntersecting ? this.waiting.get(entry.target) : undefined;
					if (!run) continue;
					this.forget(entry.target);
					run();
				}
			},
			{ rootMargin: "100% 0px" },
		);
		this.waiting.set(element, run);
		this.observer.observe(element);
		return () => this.forget(element);
	}

	forget(element: Element) {
		this.waiting.delete(element);
		this.observer?.unobserve(element);
	}

	stop() {
		this.observer?.disconnect();
		this.observer = undefined;
		this.waiting.clear();
	}
}
